import React from "react";
import { errorTypes } from "../../config/constants";
import { AudioErrorProps } from "../../interfaces/Interface";
type ErrorProps = {
  item: AudioErrorProps;
};
const AudioError = (props: ErrorProps) => {
  const { item } = props;
  switch (item.error) {
    case errorTypes.Mispronunciation:
      return (
        <>
          {" "}
          {item.unExpBreak === errorTypes.UnexpextedBreak && (
            <span className="text-gray-400 line-through bg-pink-300">
              {" [ ] "}
            </span>
          )}
          {item.missingBreak === errorTypes.MissingBreak && (
            <span className="text-gray-400 bg-gray-300">{" [ ] "}</span>
          )}
          <div
            className={`text-white border-b-4 ${
              item.monoErr === errorTypes.Monotone
                ? `border-blue-500`
                : `border-white`
            }`}
          >
            <span className="bg-yellow-400 mb-1  px-1 rounded-sm">
              {item.word}
            </span>
          </div>
        </>
      );

    case errorTypes.Omission:
      return (
        <>
          {" "}
          {item.unExpBreak === errorTypes.UnexpextedBreak && (
            <span className="text-gray-300">{" [ ] "}</span>
          )}
          <div
            className={`text-white border-b-4 ${
              item.monoErr === errorTypes.Monotone
                ? `border-blue-500`
                : `border-white`
            }`}
          >
            <div className="bg-gray-400 mb-1  px-1 rounded-sm">{item.word}</div>
          </div>
        </>
      );
    case errorTypes.Insertion:
      return (
        <>
          {" "}
          {item.unExpBreak === errorTypes.UnexpextedBreak && (
            <span className="text-gray-300">{" [ ] "}</span>
          )}
          <div
            className={`text-white border-b-4 ${
              item.monoErr === errorTypes.Monotone
                ? `border-blue-500`
                : `border-white`
            }`}
          >
            <div className="bg-red-400 mb-1  px-1 rounded-sm">{item.word}</div>
          </div>{" "}
        </>
      );
    case errorTypes.None:
      return (
        <>
          {" "}
          {item.unExpBreak === errorTypes.UnexpextedBreak && (
            <span className="text-gray-300">{" [ ] "}</span>
          )}
          <div
            className={`text-black border-b-4 ${
              item.monoErr === errorTypes.Monotone
                ? `border-blue-500`
                : `border-white `
            }`}
          >
            {item.word}
          </div>
        </>
      );
    default:
      return <div>{item.word}</div>;
  }
};

export default AudioError;
